<template>
  <div class="related-company-tab">
    <div style="max-height: 600px; overflow-y: auto;">
      <el-table 
        ref="multipleTable" 
        border 
        :cell-style="{padding: '3px'}" 
        :header-cell-style="{ background: '#FFF6EF'}"  
        style="width: 100%"  
        empty-text="暫無數據" 
        :data="relComInfo"
      >
        <el-table-column label="關聯公司" prop="LegPersonRep" min-width="30%">
        </el-table-column>
        
        <el-table-column label="關聯關係" prop="Rels" min-width="25%">
          <template slot-scope="scope">
            <div v-html="scope.row.Rels"></div>
          </template>                  
        </el-table-column>
        
        <el-table-column label="關聯人" prop="Reps" min-width="25%">
          <template slot-scope="scope">
            <div v-html="scope.row.Reps"></div>
          </template>               
        </el-table-column>
        
        <el-table-column label="異動時間" prop="DataDt" min-width="10%">
          <template slot-scope="scope">                                
            <div v-if="!!scope.row.DataDt">
              <a class="goDetailPage" @click="handleShowChange(scope.row)">
                {{ scope.row.DataDt }}
              </a>                                    
            </div>                                
          </template>  
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RelatedCompanyTab',
  
  props: {
    relComInfo: {
      type: Array,
      default: () => []
    }
  },
  
  methods: {
    handleShowChange(row) {
      this.$emit('show-change', row)
    }
  }
}
</script>

<style lang="scss" scoped>
.related-company-tab {
  .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
